import { render, staticRenderFns } from "./HighlightSnsPostMenuParts.vue?vue&type=template&id=12bb9d80&scoped=true"
import script from "./HighlightSnsPostMenuParts.vue?vue&type=script&lang=ts"
export * from "./HighlightSnsPostMenuParts.vue?vue&type=script&lang=ts"
import style0 from "./HighlightSnsPostMenuParts.vue?vue&type=style&index=0&id=12bb9d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bb9d80",
  null
  
)

export default component.exports